export default {"src":"/uk/_next/static/media/spot-laptop-compare.6d8ea49d.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};